module.exports = __webpack_public_path__ + "img/arrow-up-wide-short.9c44ee97.svg";